/* eslint-disable @typescript-eslint/naming-convention */

export const ON_PREMISE_CART_JOURNEY_PAYLOAD_KEYS = {
    IS_ON_PREMISE_FULFILMENT_ORDER: "is_on_premise_fulfilment_order",
    ORDER_PREFERENCE: "order_preference",
    AUDI_NUMBER: "audi_number",
    SEAT_NUMBER: "seat_number",
    MOBILE_NUMBER: "mobile_number",
} as const;

export interface OnPremiseFulfilmentData {
    is_on_premise_fulfilment_order: string;
    order_preference: string;
    audi_number: string;
    seat_number: string;
    mobile_number: string;
    title: string;
    subtitle: string;
    orderTypeTitle: string;
    orderTypeSubtitle: string;
    background?: string;
    widget_image?: string;
}
